export default function (state) {
    let data = {
        ScreenName: state.data.ScreenName,
        ItemsLegend: [],
        CustomSettings: [],
    };
    state.columns.forEach(j => {
        state.data.ItemsLegend.forEach(i => {
            if (i.FieldName !== j.name) return;
            i.IsFixed = j.fixed;
            i.IsVisible = j.visible;
            i.ColumnWidth = j.width;
            i.ColumnIndex = j.index;
            data.ItemsLegend.push(i);
        });
    });
    for (let k in state) {
        switch (k) {
            case 'loading':
            case 'visible':
            case 'cbs':
            case 'rebind':
            case 'data':
            case 'old':
                break;
            default:
                data.CustomSettings.push({
                    Name: k,
                    Value: JSON.stringify(state[k]),
                });
        }
    }
    return data;
}